import { Colors } from '@/constants/theme';
import React, { ReactNode } from 'react';
import { StyleSheet } from 'react-native';
import Animated, {
  interpolate,
  interpolateColor,
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from 'react-native-reanimated';
import { View } from './tw-wrappers';

export function PrimaryHoverCard({
  children,
  backgroundColor,
  borderColor,
  borderWidth,
  className,
  style,
}: {
  children: ReactNode;
  backgroundColor?: string;
  borderColor?: string;
  borderWidth?: number;
  className?: string;
  style?: any;
}) {
  const hoverProgress = useSharedValue(0);

  const animatedStyle = useAnimatedStyle(() => {
    const radius = interpolate(hoverProgress.value, [0, 1], [0, 15]);
    const opacity = interpolate(hoverProgress.value, [0, 1], [0, 0.3]);

    const finalBorderColor = interpolateColor(
      hoverProgress.value,
      [0, 1],
      [borderColor || 'rgba(0,0,0,0.05)', Colors.light.primary]
    );

    return {
      borderColor: finalBorderColor,
      shadowColor: Colors.light.primary,
      shadowOffset: {
        width: 0,
        height: 0,
      },
      shadowRadius: radius,
      shadowOpacity: opacity,
      elevation: interpolate(hoverProgress.value, [0, 1], [0, 12]),
      // @ts-ignore - boxShadow is web-only
      boxShadow: `0px 0px ${radius}px rgba(11, 95, 255, ${opacity})`,
    };
  });

  const isFlexing = className?.includes('flex-1') || className?.includes('h-full');

  return (
    <View
      className={className}
      style={style}
      onMouseEnter={() => (hoverProgress.value = withTiming(1, { duration: 400 }))}
      onMouseLeave={() => (hoverProgress.value = withTiming(0, { duration: 400 }))}>
      <Animated.View
        style={[
          styles.card,
          backgroundColor ? { backgroundColor } : { backgroundColor: '#ffffff' },
          borderWidth ? { borderWidth } : null,
          animatedStyle,
          isFlexing && { flex: 1 },
        ]}>
        {children}
      </Animated.View>
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    borderRadius: 16,
    padding: 20,
    borderWidth: 1,
    borderColor: 'rgba(0,0,0,0.05)',
    gap: 12,
    position: 'relative',
  },
});
